import type { ReactNode } from 'react';
import { useDemoSystemEnabled } from '@/shared/config/useFeatures';

/**
 * slice-3626 (ADR-0050): route wrapper for demo-instance-only screens. When the instance's
 * {@code demoSystem} flag is off the route renders the same "Not found." the router uses
 * for unknown paths — a pasted URL on ph10-test or APEX shows nothing, and the backend's
 * DemoSystemGate 404s the matching APIs anyway.
 */
export function RequireDemoSystem({ children }: { children: ReactNode }) {
  const enabled = useDemoSystemEnabled();
  if (!enabled) return <div className="text-slate-500">Not found.</div>;
  return <>{children}</>;
}
